const EQUALWEB_STANDARD_TOKENS = [
  'INDTextReaderSettings',
  'INDbtnPosition',
  'INDa11yConfig',
  'INDFontSize',
  'INDBigCursor',
  'INDColorScheme',
  'INDVirtualKeyboard',
  'INDtextmagnifier',
  'INDHighlight',
  'INDAltText',
  'INDReadableFont',
  'INDMagnifier',
  'INDTextReader'
];

const hasSomeEqualWebAccessabilityOptionActive = () => {
  const activeOptions = Object.keys(localStorage).filter(key => key.startsWith('IND') && !EQUALWEB_STANDARD_TOKENS.includes(key));
  return activeOptions.length !== 0;
};

export {
  hasSomeEqualWebAccessabilityOptionActive,
  EQUALWEB_STANDARD_TOKENS
};
